export default __webpack_public_path__ + "static/ocean-florida-f244efe38b5137b1e5d09a88600178fe.png";